import React from 'react';
import { OrderedMap } from 'immutable';
import { Row, Col } from 'bootstrap';
import TimeUtil from 'time';
import classnames from 'classnames';
import Placeholder from 'shared/components/misc/placeholder';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import { DragSource } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';
import DraggableTypes from './draggableTypes';
import { List } from 'react-virtualized';
import TagList from 'shared/components/tag/tagList';

// NOTE THIS FILE HAS MANY PROP TYPE VIOLATIONS
// AND ALL ARE DISABLED BY THE COMMENT BELOW.
/* eslint-disable react/prop-types */

/**
 * Number of clicks on the globey easter egg before globey shows himself
 * @type {[type]}
 */
const GlobeyNumClicks = 10;

/**
 * Number of rows to show for placeholder content (while real data is loading)
 */
const PlaceholderRowCount = 12;

/**
 * Row height constant for the `react-virtualized` List
 */
const RVFixedRowHeight = 42;
/**
 * Number of rows to render for the `react-virtualized` List outside the viewport
 */
const RVOverscanCount = 5;
/**
 * Height of the `react-virtualized` List
 */
const RVListHeight = 500;
/**
 * Width of the `react-virtualized` List
 */
const RVListWidth = 784;

/**
 * InsertGlobalElementList component
 */
export default React.createClass({
  mixins: [PureRenderMixin],

  getInitialState() {
    return {
      globeyClicks: 0,
    };
  },

  displayName: 'InsertGlobalElementList',

  propTypes: {
    eventId: React.PropTypes.string,
    showId: React.PropTypes.string,
    itemSetListId: React.PropTypes.string,
    itemSetId: React.PropTypes.string,
    items: React.PropTypes.object,
    tags: React.PropTypes.object,
    activeGlobalElementShowItems: React.PropTypes.array,
  },

  getDefaultProps() {
    return {
      activeGlobalElementShowItems: [],
    };
  },

  componentDidUpdate(prevProps, prevState) {
    /**
     * `react-virtualized` List component doesn't take `items` as an argument,
     *  so it's not aware of a change. When the `items` change, we force a
     *  render pass by calling this public method
     */
    if (
      this.props.itemSetId !== prevProps.itemSetId ||
      this.props.items !== prevProps.items ||
      (this.state.globeyClicks >= GlobeyNumClicks &&
        prevState.globeyClicks < GlobeyNumClicks) ||
      this.props.activeGlobalElementShowItems.length !==
        prevProps.activeGlobalElementShowItems.length
    ) {
      this._listRef.forceUpdateGrid();
    }
  },

  render() {
    const { items } = this.props;

    return (
      <div>
        <List
          ref={(ref) => (this._listRef = ref)}
          height={RVListHeight}
          width={RVListWidth}
          overscanRowCount={RVOverscanCount}
          rowCount={items.size}
          rowHeight={RVFixedRowHeight}
          rowRenderer={this._rowRenderer}
        />
        <div
          style={{
            fontSize: 8,
            color: 'rgba(242, 243, 242, .5)',
            position: 'relative',
            top: '10px',
          }}
          onClick={() => {
            this.setState({ globeyClicks: this.state.globeyClicks + 1 });
          }}
        >
          Globey :)
        </div>
      </div>
    );
  },

  // eslint-disable-next-line react/prop-types, no-unused-vars
  _rowRenderer({ index, isScrolling, key, style }) {
    const {
      items,
      eventId,
      showId,
      itemSetListId,
      itemSetId,
      tags,
      activeGlobalElementShowItems,
    } = this.props;

    const geLookup = {};

    /**
     * The active global element show items represent which global
     * element rows and how many of each row have been added to the current show.
     */
    activeGlobalElementShowItems.forEach((item) => {
      if (!geLookup[item.sourceRow]) geLookup[item.sourceRow] = [];
      geLookup[item.sourceRow].push(item);
    });

    const row = items.toArray()[index];

    return (
      <div style={style} key={key}>
        <DraggableElementListItem
          {...{
            eventId,
            showId,
            itemSetListId,
            itemSetId,
            tags,
            row,
            index,
            activeGlobalElements: geLookup[row.get('_id')],
            showGlobey: this.state.globeyClicks >= GlobeyNumClicks,
          }}
        />
      </div>
    );
  },

  _getPlaceholderRows() {
    const placeholderRows = [];

    while (placeholderRows.length < PlaceholderRowCount) {
      placeholderRows.push(
        // eslint-disable-next-line no-undef
        <PlaceholderRow key={`ge-placeholder-row-${index}`} index={index} />,
      );
    }

    return <div>{placeholderRows}</div>;
  },
});

/**
 * PlaceHolderRow component
 * @param {[type]} index [description]
 */
const PlaceholderRow = ({ index }) => (
  <div className="ge-insert-item-color">
    <Row className="ge-insert-modal-col-item ge-insert-modal-placeholder-col-wrapper">
      <span>
        <Col lg={12} md={10} sm={9}>
          <div className="ge-insert-modal-col-item-value ge-indx">
            {index + 1}
          </div>
          <Placeholder width="60%" />
        </Col>
        <Col lg={4} md={4} className="hidden-sm hidden-xs">
          <Placeholder width="100%" />
        </Col>
        <Col lg={4} md={4} className="hidden-sm hidden-xs">
          <Placeholder width="100%" />
        </Col>
        <Col lg={3} className="hidden-sm hidden-xs hidden-md">
          <Placeholder width="50%" />
        </Col>
      </span>
    </Row>
  </div>
);

/**
 * FormattedDuration component
 * @param {[type]} duration [description]
 */
const FormattedDuration = ({ duration }) => {
  return <span>{TimeUtil.getShorthandDuration(duration)}</span>;
};

/**
 * GEName component
 * @param {[type]}  item       [description]
 * @param {Boolean} isDragging [description]
 * @param {[type]}  titleRow   [description]
 */
const GEName = ({ item, isDragging, titleRow }) => {
  const style = isDragging
    ? { color: 'white', paddingLeft: '16px' }
    : { cursor: '-webkit-grab' };

  return (
    <div
      style={style}
      className={classnames('ge-insert-modal-col-item-value', {
        'title-row-item': titleRow,
      })}
    >
      {item.get('title') || 'Item'}
    </div>
  );
};

/**
 * item style getter function
 * @param  {Object}  [draggableStyle={}] [description]
 * @param  {Boolean} isDragging          [description]
 * @return [type]                        [description]
 */
const getItemStyle = (draggableStyle = {}, isDragging) => {
  const initStyle = isDragging
    ? {
        userSelect: 'none',
        backgroundColor: 'rgba(144, 101, 255, 0.9)',
        color: 'white',
        border: '2px solid #573C99',
        boxShadow: '0px 4px 8px #DED1FF',
        borderRadius: 2,
        cursor: 'move',
      }
    : {
        userSelect: 'none',
      };

  //Adjust the position slightly so that the element is more under the mouse cursor (https://github.com/SHOFLO/Issues/issues/3689)
  draggableStyle.top = isDragging
    ? draggableStyle.top - 26
    : draggableStyle.top;

  return Object.assign(initStyle, draggableStyle);
};

/**
 * Drag source specification for the the list item
 * @type {Object}
 */
const listItemDragSource = {
  beginDrag: ({
    eventId,
    showId,
    itemSetListId,
    itemSetId,
    row,
    showGlobey,
  }) => {
    return { eventId, showId, itemSetListId, itemSetId, row, showGlobey };
  },
};

/**
 * Drag collect function for the list item DragSource
 * @param  {[type]} connect [description]
 * @param  {[type]} monitor [description]
 * @return [type]           [description]
 */
// eslint-disable-next-line no-unused-vars
const dragCollect = (connect, monitor) => {
  return {
    connectDragPreview: connect.dragPreview(),
    connectDragSource: connect.dragSource(),
  };
};

/**
 * ElementListItem component
 * @type {[type]}
 */
const ElementListItem = React.createClass({
  mixins: [PureRenderMixin],

  propTypes: {
    index: React.PropTypes.number,
    row: React.PropTypes.object,
    tags: React.PropTypes.object,
    activeGlobalElements: React.PropTypes.array,
    connectDragSource: React.PropTypes.func,
  },

  componentDidMount() {
    const { connectDragPreview } = this.props;

    if (connectDragPreview) {
      // Use empty image as a drag preview so browsers don't draw it
      // and we can draw whatever we want on the custom drag layer instead.
      connectDragPreview(getEmptyImage(), {
        // IE fallback: specify that we'd rather screenshot the node
        // when it already knows it's being dragged so we can hide it with CSS.
        captureDraggingState: true,
      });
    }
  },

  render() {
    const { index, row, activeGlobalElements } = this.props;

    // const rowId = row.get('_id');
    const titleRow = row.get('titleRow');
    return (
      <div className="ge-insert-item-color">
        <div>
          <Row
            style={getItemStyle()}
            className={classnames('ge-insert-modal-col-item', {
              dragging: false,
            })}
          >
            {this._getGENonDragContentNode(
              row,
              false,
              index,
              titleRow,
              activeGlobalElements,
            )}
          </Row>
        </div>
      </div>
    );
  },

  _getGENonDragContentNode(
    row,
    isDragging,
    index,
    titleRow,
    activeGlobalElements,
  ) {
    if (!row) return null;
    const { connectDragSource } = this.props;

    const item = row.get('item');

    const activeGlobalElementsQuantity = activeGlobalElements
      ? activeGlobalElements.length
      : 0;

    return (
      <span>
        {connectDragSource(
          <div>
            <Col lg={11} md={9} sm={8}>
              {activeGlobalElements ? (
                <div className="ge-insert-modal-col-item-global-element-qty ge-indx">
                  <span className="global-element-qty-pill">
                    {activeGlobalElementsQuantity}
                  </span>
                </div>
              ) : null}
              {<GEName {...{ item, isDragging, titleRow }} />}
            </Col>
          </div>,
        )}
        <LabelField
          popoverId={row.get('_id')}
          rowTags={row.get('labels')}
          tags={this.props.tags}
        />
        <DurationField duration={item.get('durationInSeconds')} />
      </span>
    );
  },
});

const DraggableElementListItem = DragSource(
  DraggableTypes.GEMItem,
  listItemDragSource,
  dragCollect,
)(ElementListItem);

/**
 * DurationField component
 */
const DurationField = React.createClass({
  mixins: [PureRenderMixin],

  propTypes: {
    duration: React.PropTypes.number,
  },

  render() {
    const { duration } = this.props;

    return (
      <Col lg={2} className="hidden-sm hidden-xs hidden-md">
        <div className="ge-insert-modal-col-item-value duration">
          <FormattedDuration duration={duration} />
        </div>
      </Col>
    );
  },
});

/**
 * LabelField component
 */
const LabelField = React.createClass({
  mixins: [PureRenderMixin],

  propTypes: {
    popoverId: React.PropTypes.string,
    rowTags: React.PropTypes.array,
    tags: React.PropTypes.object,
  },

  render() {
    const { rowTags, tags, popoverId } = this.props;

    if (!tags) return null;

    const activeTags = OrderedMap(
      rowTags
        .map((tagId) => [tagId, tags.get(tagId)])
        .filter((item) => item[1]),
    );

    return (
      <Col lg={10} md={13} className="hidden-sm hidden-xs">
        <div className="ge-insert-modal-col-label-wrapper">
          <TagList
            width={300}
            tagFilters={activeTags}
            tags={activeTags}
            popoverId={popoverId}
            popoverTitle="Applied tags"
            popoverClasses="element-list-tag-popover"
            disableFilterSorting
          />
        </div>
      </Col>
    );
  },
});
